import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const useStyles = makeStyles((theme) => ({
  processing: {
    background: theme.palette.primary.main,
  },
  scheduled: {
    background: '#F9A825',
  },
  draft: {
    background: theme.palette.primary.light,
  },
  delivered: {
    background: theme.palette.success.light,
  },
  live: {
    background: theme.palette.success.light,
  },
  disabled: {
    background: theme.palette.text.disabled,
  },
  disabledText: {
    color: theme.palette.text.disabled,
  },
  indicator: {
    width: theme.typography.pxToRem(10),
    height: theme.typography.pxToRem(10),
  },
}))
const StatusIndicator = ({ disabled, status }) => {
  const classes = useStyles()
  return (
    <Typography
      color="textSecondary"
      className={cn({ [classes.disabledText]: disabled })}
    >
      <Box
        component="span"
        display="inline-block"
        mr={1}
        borderRadius="50%"
        opacity={0.9}
        className={cn(classes.indicator, classes[status.toLowerCase()])}
        aria-hidden="true"
      />
      {status}
    </Typography>
  )
}
StatusIndicator.propTypes = {
  disabled: PropTypes.bool,
  status: PropTypes.oneOf(['Draft', 'Processing', 'Scheduled', 'Delivered']),
}
export default StatusIndicator
